import React from "react";
import { menuStyles } from "./style.js";
import SearchBar from "../SearchBar";
import ImageUploader from "../ImageUploader";

const MenuBar = ({ disconnect, userInfo, updateUserInfo }) => {
  const highlight = (e) => {
    e.target.style.opacity = 0.5;
  };

  const unhighlight = (e) => {
    e.target.style.opacity = 1;
  };

  return (
    <div style={menuStyles.bar}>
      <ImageUploader
        previewWidth={40}
        previewHeight={40}
        imageUrl={userInfo.profileUrl}
        setImageUrl={async (url) => {
          const msg = await updateUserInfo({ profileUrl: url });
        }}
      />
      <SearchBar width={200} />
      <div
        style={menuStyles.logOutBtn}
        onClick={async () => await disconnect()}
        onMouseOver={highlight}
        onMouseOut={unhighlight}
      >
        Disconnect
      </div>
    </div>
  );
};

export default MenuBar;
